interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Thorchain = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_27157)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="url(#paint0_linear_188_27157)"
      />
      <path
        d="M76.0606 20L39.3348 35.3408L65.8075 62.4711L24 80L52.3081 49.2348L76.0606 20Z"
        fill="#4D1F99"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_188_27157"
        x1="16"
        y1="88.5"
        x2="81"
        y2="13"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#04D0F9" />
        <stop
          offset="1"
          stopColor="#31FCA0"
        />
      </linearGradient>
      <clipPath id="clip0_188_27157">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
